export default {
    methods: {
        async _getCountryByCode(countryCode) {
          const response = await fetch(`https://restcountries.com/v2/alpha/${countryCode}`);

          return response.json();
        },
    },
};